(() => {
  if (customElements.get('mm-shipping-quote') || !window.MMShipping) return;
  const {ShippingElement, readCart, cartSignature, productRates} = window.MMShipping;
  class MMShippingQuote extends ShippingElement {
    connectedCallback() {
      super.connectedCallback();
      this.productContainer = this.closest('.product-template__wrapper');
      this._contextChange = event => {
        if (event.target?.closest?.('mm-shipping-quote')) return;
        if (event.target?.closest?.('mm-kit-options') || event.target?.name === 'quantity' || event.target?.name === 'id' || event.target?.name?.startsWith('options[')) this.invalidate();
      };
      this.productContainer?.addEventListener('input', this._contextChange);
      this.productContainer?.addEventListener('change', this._contextChange);
      this._variantChange = () => this.invalidate();
      this.productContainer?.addEventListener('mm:kit-change', this._variantChange);
      this.variantEvents = typeof PRODUCT_EVENT === 'object'
        ? [`${PRODUCT_EVENT.updatedVariant}${this.dataset.sectionId}`, `${PRODUCT_EVENT.swatchChange}${this.dataset.sectionId}`]
        : [];
      this.variantEvents.forEach(name => document.addEventListener(name, this._variantChange));
      this._cartChange = () => this.invalidate();
      this.cartEvent = typeof CART_EVENT === 'object' ? CART_EVENT.cartUpdate : 'cart:updated';
      document.addEventListener(this.cartEvent, this._cartChange);
    }
    disconnectedCallback() {
      super.disconnectedCallback();
      this.productContainer?.removeEventListener('input', this._contextChange);
      this.productContainer?.removeEventListener('change', this._contextChange);
      this.productContainer?.removeEventListener('mm:kit-change', this._variantChange);
      this.variantEvents?.forEach(name => document.removeEventListener(name, this._variantChange));
      document.removeEventListener(this.cartEvent, this._cartChange);
    }
    productContext() {
      const form = this.productContainer?.querySelector('form[data-type="add-to-cart-form"]');
      if (!form) throw new Error('INVALID_PRODUCT');
      const kit = this.productContainer?.querySelector('mm-kit-options');
      if (kit) {
        if (typeof kit.shippingContext !== 'function') throw new Error('INVALID_PRODUCT');
        return kit.shippingContext(form);
      }
      const data = new FormData(form);
      const variant = String(data.get('id') || '');
      const button = form.querySelector('.product-form__btn-add-to-cart');
      if (!/^\d+$/.test(variant) || !button || button.disabled || button.getAttribute('aria-disabled') === 'true') throw new Error('INVALID_PRODUCT');
      const input = [...form.elements].find(element => element.name === 'quantity' && !element.disabled);
      const quantity = Number(data.get('quantity') ?? (input?.min || 1));
      const min = Number(input?.min || 1);
      const max = input?.max ? Number(input.max) : Infinity;
      const step = Number(input?.step || 1);
      if (!Number.isInteger(quantity) || quantity < Math.max(1, min) || quantity > max || !Number.isFinite(step) || step <= 0 || quantity % step !== 0) throw new Error('INVALID_QUANTITY');
      return {variant, quantity, sellingPlan: String(data.get('selling_plan') || '')};
    }
    async context(signal) {
      const product = this.productContext();
      const cart = await readCart(signal);
      return {...product, cartSignature: cartSignature(cart), currency: cart.currency, cartCount: cart.item_count};
    }
    async matches(previous, signal) {
      try {
        const current = this.productContext();
        const product = {variant: previous.variant, quantity: previous.quantity, sellingPlan: previous.sellingPlan};
        if (previous.items) product.items = previous.items;
        return JSON.stringify(current) === JSON.stringify(product) && cartSignature(await readCart(signal)) === previous.cartSignature;
      } catch (_) { return false; }
    }
    async rates(context, zip, address, signal) {
      const rates = await productRates(context, zip, address, signal);
      this.quotedCartCount = context.cartCount;
      return [{options: rates.map(rate => ({handle: rate.code, title: rate.presentment_name || rate.name,
        description: this.deliveryText(rate), amount: rate.price, currency: rate.currency || context.currency}))}];
    }
    render(groups, zip, address) {
      super.render(groups, zip, address);
      if (this.quotedCartCount > 0) this.message(`${this.status.textContent} · ${this.text('cart_scope')}`);
    }
  }
  customElements.define('mm-shipping-quote', MMShippingQuote);
})();

